import React, { useContext } from 'react'

export const ReadOnlyContext = React.createContext(false)

export const useReadOnly = () => useContext(ReadOnlyContext)

export const FieldsLockedContext = React.createContext(false)

export const useFieldsLocked = () => useContext(FieldsLockedContext)
